/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Person/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Name from './Name/index'
import React from 'react'
import Relation from './Relation/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Person({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/Addresses/Content/Address/AddressLines/Related/Content/Popup/Content/Persons/Person"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Person.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z2fMjSV': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<Relation
  viewPath={`${viewPath}/Relation`}
/>
</div>
{children}
</React.Fragment>)
}